export default __webpack_public_path__ + "static/media/GroupAccidentalImage.948ab5c6.svg";